<div class="signup">
  <h1>Comece a usar o NCommerce</h1>

  @if (!sentTo) {
    @if (chosenPlan) {
      <p class="chosen-plan">Plano escolhido: <strong>{{ planNames[chosenPlan] }}</strong>
        @if (chosenPlan !== 'free') { · você só paga depois que o sistema estiver instalado }</p>
    }
    <p>Deixe seus dados. Vamos enviar um link por e-mail e WhatsApp para você concluir o cadastro
      <strong>no computador onde o sistema vai ficar instalado</strong>.</p>

    <form class="card-form" (ngSubmit)="send()">
      <label class="form-label" for="lead-name">Seu nome</label>
      <input id="lead-name" class="form-control" name="name" [(ngModel)]="name" autocomplete="name" maxlength="100">

      <label class="form-label" for="lead-email">E-mail</label>
      <input id="lead-email" class="form-control" name="email" type="email" [(ngModel)]="email" autocomplete="email" maxlength="150">

      <label class="form-label" for="lead-whatsapp">WhatsApp</label>
      <input id="lead-whatsapp" class="form-control" name="whatsapp" [(ngModel)]="whatsapp" mask="(00) 0000-0000||(00) 0 0000-0000"
        placeholder="(62) 9 9999-9999" autocomplete="tel">

      <button class="btn btn-primary btn-lg w-100" type="submit" [disabled]="loading || !canSend()">
        {{ loading ? 'Enviando...' : 'Receber o link' }}
      </button>
      @if (error) {
        <p class="error">{{ error }}</p>
      }
    </form>

    <p class="fine">Ao continuar, você concorda em receber mensagens sobre o seu cadastro. Veja a
      <a routerLink="/privacidade">Política de Privacidade</a>.</p>
  } @else {
    <div class="card-form done">
      <h2>Link enviado!</h2>
      <p>Mandamos o link para <strong>{{ sentTo }}</strong> e para o seu WhatsApp.</p>
      <p>Abra o link <strong>no computador onde o NCommerce vai ficar</strong> (Windows 10, Windows 11 ou Ubuntu).
        Ele vale por 7 dias.</p>
      <p class="fine">Já tem conta? Entre na <a routerLink="/cliente">Área do Cliente</a>.</p>
      <p class="fine">Não chegou? Confira a caixa de spam ou <button class="btn btn-link p-0 align-baseline" type="button" (click)="sentTo = ''">peça de novo</button>.</p>
    </div>
  }
</div>
